import { createAction, createReducer } from "@reduxjs/toolkit";
import { getTokenExpirationTime, isTokenExpired } from "../utils/token";

const storageName = "auth";

function readStoredAuth() {
    try {
        return JSON.parse(localStorage.getItem(storageName));
    } catch {
        localStorage.removeItem(storageName);
        return null;
    }
}

let data = readStoredAuth();

if (data && isTokenExpired(data.tokenExpirationTime)) {
    localStorage.removeItem(storageName);
    data = null;
}

const initialState = {
    user: data?.user,
    tokenValue: data?.tokenValue,
    tokenExpirationTime: data?.tokenExpirationTime,
};

export const login = createAction("LOGIN", (profile, token) => ({
    payload: {
        user: profile,
        tokenValue: token,
        tokenExpirationTime: getTokenExpirationTime(token),
    },
}));

export const logout = createAction("LOGOUT");

export const changeProfile = createAction("CHANGE_PROFILE", (d) => ({
    payload: { user: d },
}));

export const updateUserImage = createAction("UPDATE_USER_IMAGE", (imageUrl) => ({
    payload: imageUrl,
}));

export default createReducer(initialState, (builder) => {
    builder
        .addCase(login, (state, action) => {
            state.user = action.payload.user;
            state.tokenValue = action.payload.tokenValue;
            state.tokenExpirationTime = action.payload.tokenExpirationTime;
            localStorage.setItem(storageName, JSON.stringify(state));
        })
        .addCase(logout, (state) => {
            state.user = null;
            state.tokenValue = null;
            state.tokenExpirationTime = null;
            localStorage.removeItem(storageName);
        })
        .addCase(changeProfile, (state, action) => {
            state.user = { ...state.user, ...action.payload.user };
            localStorage.setItem(storageName, JSON.stringify(state));
        })
        .addCase(updateUserImage, (state, action) => {
            if (state.user) {
                state.user.image = action.payload;
            }
            localStorage.setItem(storageName, JSON.stringify(state));
        });
});
